import React, { useEffect } from 'react';
import { Footer, Navbar } from '../../components';

const Home = () => {
    useEffect(() => {
        window.analytics.page('Home');
    }, []);

    useEffect(() => {
        window.location.href = '/';
    }, []);

    return (
        <>
            <Navbar navContainer="container-wide" />
            <Footer />
        </>
    );
};
export default Home;
